import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'components/shared/heading';
import classNames from 'classnames/bind';

import HubspotForm from 'components/shared/hubspot-form';
import { FORM_IDS } from 'constants/form';

import styles from './hero-with-form.module.scss';

const cx = classNames.bind(styles);

const HeroWithForm = ({ title, description = null, backgroundImage }) => (
  <section className={cx('wrapper')}>
    <div className={cx('container', 'inner')}>
      <div className={cx('left')}>
        <Heading className={cx('title')} size="xl">
          {title}
        </Heading>
        {description && <p className={cx('description')}>{description}</p>}
      </div>

      <div className={cx('right')}>
        <HubspotForm formId={FORM_IDS.CONTACT_US} targetId="hubspotHeroWithForm" />
      </div>
    </div>

    <img
      className={cx('image')}
      srcSet={backgroundImage.srcset}
      alt=""
      loading="eager"
      fetchPriority="high"
    />
  </section>
);

HeroWithForm.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  backgroundImage: PropTypes.shape({
    srcset: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
};

export default HeroWithForm;
